import { Suspense } from 'react';
import { Drawer, Loader } from '@nearst/ui';
import StockLevels from '.';

import styles from './StockLevels.module.scss';

const StockLevelsDrawer = ({ barcode, setBarcode }) => {
	return (
		<Drawer open={!!barcode} onOpenChange={() => setBarcode(null)} className={styles.drawer}>
			<Drawer.Header>
				<Drawer.Title>Stock levels</Drawer.Title>
				<Drawer.Close />
			</Drawer.Header>

			<Suspense fallback={<Loader />}>{barcode && <StockLevels barcode={barcode} />}</Suspense>
		</Drawer>
	);
};

export default StockLevelsDrawer;
